import { z } from 'zod';

/**
 * The member's own recent tracking signal, as the model sees it.
 *
 * Every field is clinical member content: it reaches the model and the stored
 * decision copy, and nothing else. Never a log line, metric tag, span
 * attribute, analytics property, or bus payload.
 */
export const checkInSignalSchema = z
  .object({
    /**
     * Detail from the bounded trailing window, or `null` when that window held
     * nothing usable — which says nothing about whether they ever tracked.
     */
    recency: z
      .object({
        streak: z.number().int().min(0),
        weekCount: z.number().int().min(0),
        lastDate: z.string(),
        lastMoods: z.array(z.string()),
        lastNote: z.string().nullable(),
        lastTagGroups: z.array(z.object({ group: z.string(), tags: z.array(z.string()) }).strict()),
      })
      .strict()
      .nullable(),
    /** The most recent tracked day; `null` only when the member never tracked. */
    lastCheckInDate: z.string().nullable(),
    /** Whole calendar days from `lastCheckInDate` to the reminder's day; `null` with it. */
    daysSinceLastCheckIn: z.number().int().nullable(),
  })
  .strict();
export type CheckInSignal = z.infer<typeof checkInSignalSchema>;
